<template>
  <div class="d-flex-column main_container" v-if="packSlot">
    <div class="pack_timing_fc b-radius-12" v-if="packSlot">
      <div class="image_container">
        <img
          :src="`${packSlot?.image}?v=3`"
          alt="piggy_bank"
          class="piggy_bank_image"
        />
      </div>

      <div
        class="d-flex-row space-between height-max-content gap-50 description-container"
      >
        <div class="d-flex-column justify-start align-start gap-3 flex-7">
          <h5 class="t-white font-family-2 bold-xxl">
            {{ packSlot?.season_title }}
          </h5>
          <p class="t-grey font-family-2 medium-m">
            {{ $t("pack_time.description") }}
          </p>
        </div>
        <div
          class="d-flex-column justify-start align-end gap-3 flex-3 time_container"
          v-if="!isBetweenFriday8AmAndMondayInGMT"
        >
          <p class="t-grey font-family-2 medium-s">
            {{ $t("pack_time.preorder_closes_in") }}
          </p>

          <CountdownTimer />
        </div>
        <!-- <div
          class="width-max-content justify-end d-flex-row completion_container b-radius-8"
          v-else-if="isFriday"
        >
          <NewPackChip
            :title="$t('pack_time.fut_finals_live')"
            variant="fc-boost"
          />
        </div> -->

        <div
          class="width-max-content justify-end d-flex-row completion_container b-radius-8"
          v-else-if="isBetweenFriday8AmAndMondayInGMT"
        >
          <p class="live-text font-family-1 f-w-500">
            {{ $t("pack_time.fut_finals_live") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import CountdownTimer from "./CountdownTimer.vue";
import NewPackChip from "../cards/NewPackChip.vue";
const gameStore = useGameStore();

const packSlot = computed(() => {
  return gameStore?.getGamePack?.pack_slots;
});

const isFriday = computed(() => {
  const now = new Date();
  const isFriday = now.getDay() === 5; // 0 = Sunday, 5 = Friday

  if (!isFriday) return false;

  const hours = now.getHours();
  const minutes = now.getMinutes();

  return hours > 8 || (hours === 8 && minutes >= 0);
});

const isBetweenFriday8AmAndMondayInGMT = computed(() => {
  const now = new Date();

  // Get UK time components
  const ukTime = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    weekday: "short",
  }).formatToParts(now);

  const parts = {};
  for (const part of ukTime) {
    if (part.type !== "literal") {
      parts[part.type] = part.value;
    }
  }

  const weekday = parts.weekday;
  const hour = parseInt(parts.hour);
  const minute = parseInt(parts.minute);
  if (weekday === "Fri" && hour >= 20) {
    return true;
  }

  if (weekday === "Sat" && (hour < 8 || (hour === 8 && minute === 0))) {
    return true;
  }

  return false;
});
</script>

<style lang="scss" scoped>
@import "../../assets/scss/fonts.scss";
.main_container {
  position: relative;
  .new_pack_chip {
    transform: none;
    position: relative;
    left: 0;
    top: 0;
    width: 100%;
    min-height: 25px !important;
  }
}
.pack_timing_fc {
  width: 100%;
  border-radius: 12px;
  height: max-content;
  min-height: 104px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 15px;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid rgba(7, 244, 104, 0.2);

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 12px !important;
    -moz-border-radius: 12px !important;
    -webkit-border-radius: 12px !important;
    // background: var(--fc-25);
    background: linear-gradient(
      90deg,
      rgba(7, 244, 104, 1) 0%,
      rgba(8, 9, 10, 1) 60%
    );

    filter: blur(100px);
    top: 0;
    opacity: 0.2;
    z-index: 0;
    left: 0%;
  }

  .description-container {
    padding: 20px;
    padding-left: 0px;
  }
  .image_container {
    width: 100%;
    max-width: 124px;
    position: relative;
    overflow: hidden;
    min-height: 104px;
    height: 100%;

    .piggy_bank_image {
      position: absolute;
      width: 100%;
      height: auto;
      bottom: -30%;
      max-width: 113px;
    }
  }

  .completion_container {
    position: relative;
    overflow: hidden;
    &::after {
      content: "";
      height: 1px;
      position: absolute;
      background-color: var(--fc-25);
      bottom: 0;
      left: 0;
      animation: lineMovement 3s infinite;
    }
  }
  .live-text {
    color: #07f468;
    line-height: normal;
    font-size: 16px;
  }

  @media screen and (min-width: 1200px) and (max-width: 1560px) {
    .description-container {
      flex-direction: column;
      gap: 5px;
      padding-bottom: 1px;
    }
  }
  @media screen and (max-width: 600px) {
    flex-direction: row-reverse;
    min-height: 180px;

    &::before {
      background: linear-gradient(
        160deg,
        rgba(7, 244, 104, 1) 0%,
        rgba(8, 9, 10, 1) 60%
      );
    }

    .image_container {
      position: absolute;
      right: 0;
      bottom: 0;
      height: max-content;
    }
    .description-container {
      padding-left: 20px;
      height: 180px !important;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 20px;
      padding-bottom: 10px;
      button {
        width: 100%;
      }
    }
    .time_container {
      justify-content: flex-start;
      align-items: flex-start !important;
    }
  }
  @media screen and (max-width: 320px) {
    .image_container {
      display: none;
    }
  }
}
</style>
